import styled from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';

export const ContentWrap = styled.div`
    padding: 30px;
    border: 1px solid #eaeaea;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        padding: 0;
        border: none;
    }
`;
